import BaseComponent from "../baseComponent.js";
import Studios from "./studios/studios.jsx";
import styles from "./analytic-studio.scss";

export default class AnalyticStudio extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      studios: []
    }
  }

  componentDidMount() {
    this.resolveDependencies()
      .then(() => {
        this.setState({
          studios: require('./demo-studio-data.js')
        });
      });
  }

  resolveDependencies() {
    return new Promise((resolve, reject) => {
      try {
        require.ensure([], require => {
          require('../../vendors/jquery-ui-1.12.1.custom/jquery-ui.min.js');
          require("../../vendors/jquery-mousewheel/jquery.mousewheel.js");
          resolve();
        });
      }
      catch (err) {
        reject(err);
      }
    });
  }

  render() {

    let stateStudios = this.state.studios;
    for(let i = 0; i < stateStudios.length; i++){
      if(this.state.studios[i] != null){
        if (this.state.studios[i].inputs == null || this.state.studios[i].output == null) {
          delete this.state.studios[i];
        }
      }
    }

    return (
      <div className={styles.container}>
        <div className="row">
          <div className={["col s12", styles.searchBox].join(" ")}>
            <input placeholder="search" onChange={this.onSearchStringChange}/>
          </div>
        </div>
        <Studios studios={this.state.studios}/>;
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/analytic-studio/analyticStudio.jsx